export const TRANSLATIONS_IT = {
  components: {
    header: { text: "Hai domande?" },
    footer: {
      firstRow: "Cornèr Banca SA,",
      secondRow: "Via Canova 16, 6901 Lugano - Svizzera",
    },
  },
  screens: {
    common: {
      mr: "Signor",
      mrs: "Signora",
      haveQuestions: "Hai domande?",
      back: "Indietro",
      continue: "Avanti",
      change: "Change",
      yes: "Si",
      no: "No",
      none: "Nessuno",
      other: "Altro",
      confirm: "Conferma",
      remove: "Rimuovi",
      optional: "optional",
      skipStep: "Salta questo passaggio",
      backHome: "Vai al sito",
      cancelOnboarding: "Annulla l’onboarding",
      search: "Cerca",
      disclaimer: "Disclaimer",
      impressum: "Impressum",
      copyrightAddr: "Tödistrasse 27, CH-8002, Zurigo - Svizzera",
      errorDate: "Età accettata da 18 a 65",
      underageBo: "L’avente diritto economico deve essere maggiorenne.",
      chZipRequired: "Per favore inserisci un codice postale valido.",
      readOnlyMessage:
        "Eventuali informazioni errate che non possono essere modificate su questa pagina devono essere segnalate a Cornèrcard.",
      disclaimerLink_prep:
        "https://www.prep.corner.ch/it/disclaimer/onboarding-corner3/index.html",
      disclaimerLink_prod:
        "https://www.corner.ch/it/disclaimer/onboarding-corner3/index.html",
    },
    personalData: {
      pageTitle: "Cominciamo!",
      pageSubtitle: "Apri il tuo conto di previdenza Cornèr3 in pochi minuti.",
      firstName: "Nome",
      lastName: "Cognome",
      dataInfo:
        "Inserisci i dati esattamente come riportati sul tuo documento di identificazione.",
      email: "Indirizzo e-mail",
      phoneNr: "Numero di telefono",
      emailRequired: "Inserisci un indirizzo e-mail valido",
      phoneRequired: "Solo in formato numerico, ad es. 7812234567",
      gtcAgree:
        "Confermo di aver preso visione e di accettare il <Disclaimer>disclaimer</Disclaimer> e di soddisfare i <Requirements>requisiti per la sottoscrizione digitale del prodotto.</Requirements>",
      requirementsModal: {
        title: "Requisiti",
        subTitle:
          "La sottoscrizione digitale del prodotto è riservata a persone che:",
        data1:
          "in Svizzera sono assoggettate alle imposte in modo illimitato e conseguono un reddito soggetto all’AVS/AI derivante da un’attività lucrativa, dipendente o indipendente;",
        data2:
          "conoscono ed accettano i rischi connessi all’utilizzo di sistemi informatici e/o canali digitali, quali ad esempio siti web, piattaforme online o applicativi per smartphone messi a disposizione dalla Fondazione di Previdenza Cornèr Terzo Pilastro, dalla Cornèr Banca SA e/o da terzi.",
        understood: "Ho capito",
      },
    },
    personalDataAdditional: {
      pageTitle: "Qualche informazione su di te",
      birthDate: "Data di nascita",
      birthCountry: "Paese di nascita",
      nationality: "Nazionalità",
      maritalStatus: "Stato civile",
      maritalStatusList: {
        married: "Coniugato/a o altre unioni",
        divorced: "Divorziato/a",
        widowed: "Vedovo/a",
        unmarried: "Celibe/nubile",
        separated: "Separato/a",
      },
      avsNumber: "Il tuo numero AVS",
      avs: "Il tuo numero AVS",
      avsInfo: "<AvsInfo>Dove trovo il mio numero AVS?</AvsInfo>",
      avsModal: {
        title: "Dove trovo il numero AVS?",
        description:
          "Il numero AVS, se vivi o lavori in Svizzera, si trova facilmente sulla parte frontale della tessera della cassa malattia oppure può essere richiesto alla cassa di compensazione professionale rispettivamente del cantone di domicilio. ",
        understood: "Ho capito",
      },
    },
    address: {
      pageTitle: "Dove risiedi?",
      pageSubTitle:
        "All’indirizzo indicato saranno inviati i codici per l’accesso ai servizi digitali Cornèronline e iCornèr App.",
      country: "Nazione",
      city: "Località",
      zipCode: "NAP",
      street: "Via",
      streetNumber: "Numero civico",
    },
    employmentsDetail: {
      pageTitle: "Qual è la tua situazione professionale?",
      employed: "Dipendente",
      freelancer: "Indipendente",
      qualification: "Professione",
      pensionFund: "Sei affiliato/a a una cassa pensione (II pilastro)?",
    },
    informationRecap: {
      pageTitle: "Verifica i tuoi dati!",
      pageSubtitle:
        "Ricontrolla le informazioni inserite prima di procedere con la firma del contratto.",
      cta: "Conferma",
      personalData: "Dati anagrafici e di contatto",
      employmentsDetail: "Informazioni professionali",
      terms:
        "Confermo di aver preso visione e di accettare le <Terms>condizioni del prodotto</Terms> e le <GeneralTerms>condizioni generali della Banca</GeneralTerms>",
      termsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_IT_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      termsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/CORNER3/374a_IT_Fondazione-di-Previdenza-Corner-Terzo-Pilastro-Regolamento.pdf",
      generalTermsLink_prep:
        "https://www.prep.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_IT_Condizioni-contrattuali.pdf",
      generalTermsLink_prod:
        "https://www.corner.ch/export/sites/cornerbancaCH/.galleries/pdf/onboarding/1020_IT_Condizioni-contrattuali.pdf",
      dataChanges:
        "Se le informazioni fornite dovessero cambiare nel tempo sei tenuto/a a informare immediatamente la Banca per iscritto.",
      gender: "Titolo:",
      firstName: "Nome:",
      lastName: "Cognome:",
      email: "E-mail:",
      phoneNr: "Numero di telefono:",
      birthDate: "Data di nascita:",
      birthCountry: "Paese di nascita:",
      nationality: "Nazionalità:",
      maritalStatus: "Stato:",
      city: "Località:",
      zipCode: "NAP:",
      street: "Indirizzo di residenza:",
      streetNumber: "Numero:",
      avs: "Il tuo numero AVS:",
      currentPosition: "Situazione prefessionale:",
      qualification: "Professione:",
      pensionFund: "Sei affiliato a una cassa pensione (II Pilastro)?",
      infoModal: {
        title: "INFORMAZIONI",
        description:
          "Carica o funzione pubblica dirigenziale, attuale o precedente ricporta, all'estero o in Svizzera, a livello nazionale o internazionale. <br/>Per esempio: membro dei poteri esecutivo, legislativo o giudiziario a livello nazionale come parlamentare, capo di stato, alto funzionario dell'amministrazione, dell'esercito o di partito, membri del CdA o della direzione di imprese statali d'importanza nazionale, dirigenti di organizzazioni intergovernative o federazioni sportive internazionali, persone fisiche legate per motivi famigliari, personali o d'affari ad una persona politicamente esposta, ecc.",
        understood: "Ho capito",
      },
      disclaimerModal: {
        title: "DISCLAIMER",
        description:
          "Carica o funzione pubblica dirigenziale, attuale o precedente ricporta, all'estero o in Svizzera, a livello nazionale o internazionale. <br/>Per esempio: membro dei poteri esecutivo, legislativo o giudiziario a livello nazionale come parlamentare, capo di stato, alto funzionario dell'amministrazione, dell'esercito o di partito, membri del CdA o della direzione di imprese statali d'importanza nazionale, dirigenti di organizzazioni intergovernative o federazioni sportive internazionali, persone fisiche legate per motivi famigliari, personali o d'affari ad una persona politicamente esposta, ecc.",
        understood: "Ho capito",
      },
    },
    contractView: {
      pageTitle: "Preparati per la firma digitale!",
      pageSubtitle:
        "Prima di proseguire con la firma digitale scarica il tuo contratto. Potrai comunque visualizzarlo per intero durante il processo di video identificazione.",
      downloadBtn: "Scarica il contratto",
      btnNext: "Avanti",
    },
    videoId: {
      pageTitle: "Firma il contratto online",
      pageSubtitle: "Prepara la telecamera e un documento di identificazione.",
      mobileSubtitle:
        "Scarica l’app per la video identificazione e segui le istruzioni. <br/><br/>Il tuo codice identificativo è:<br/> <b><TICKET></b>",
      singBtn: "Firma ora",
      asset:
        "La firma digitale viene eseguita tramite video identificazione con smartphone, tablet o desktop dal nostro partner Intrum.",
    },
    videoIdUnavailable: {
      pageTitle: "Ops! <br/> Nessun operatore disponibile in questo orario",
      pageSubtitle:
        "Purtroppo, non possiamo confermare la tua identità perché non ci sono operatori disponibili in questo orario. </br>Ti abbiamo però inviato un’ <b>e-mail con il link e gli orari</b> per riprendere la video identificazione più tardi. <br/><br/>Grazie per la tua comprensione!",
      backBtn: "Chiudi",
    },
    successVideoId: {
      pageTitle: "Perfetto!",
      pageSubtitle:
        "La tua identità è stata confermata.<br/> Ti contatteremo nei prossimi giorni.",
      backBtn: "Vai al sito",
    },
    contract: {
      pageTitle: "Il contratto è pronto per essere firmato",
      pageSubtitle:
        "Stampa il contratto e segui le istruzioni riportate sulla copertina. Quindi spediscici il contratto firmato tramite posta unitamente ai documenti richiesti.",
      download: "Scarica il contratto",
      print: "Stampa il contratto",
    },
    otpResume: {
      title: "Conferma la tua identità",
      subtitle:
        "Per favore inserisci il codice a 6 cifre che ti abbiamo mandato via SMS",
      noSmsReveiced: "Non hai ricevuto il codice? Nessun problema.",
      newSmsRequest: "<0>Richiedi un nuovo codice<0>",
      otpExpired: "Your otp has expired: ask for a new one",
      otpInvalid: "Il codice OTP fornito non è valido",
      btnNext: "Avanti",
    },
    errors: {
      genericError: {
        title: "Si è verificato un errore",
        subtitle:
          "La tua richiesta non è andata a buon fine.<br/><br/>Ti preghiamo di riprovare. <br><br>",
        retry: "Riprova",
      },
      failureVideoId: {
        title: "Ops! <br/> Qualcosa non ha funzionato",
        subtitle:
          "Purtroppo, non è stato possibile confermare la tua identità.<br/>Ti preghiamo di stampare il contratto che hai scaricato in precedenza, firmarlo e spedirlo a:<br/><br/><b>Fondazione di Previdenza Cornèr Terzo Pilastro<br/>c/o Cornèr Banca SA<br/>Via Canova 16<br/>6901 Lugano<br/>Svizzera</b>",
      },
      underageNotAllowed: {
        title: "Purtroppo non possiamo elaborare la tua richiesta",
        subtitle:
          "Attualmente non è possibile fornire questo prodotto a chi non ha raggiunto la maggiore età.",
      },
      chResidenceRequired: {
        title: "Purtroppo non possiamo elaborare la tua richiesta",
        subtitle:
          "Attualmente questo prodotto viene fornito soltanto in Svizzera.",
      },
      taxResidenceMustBeCH: {
        title: "Purtroppo non possiamo elaborare la tua richiesta",
        subtitle:
          "Attualmente questo prodotto viene fornito soltanto in Svizzera.",
      },
      exsclusiveOwnershipRequired: {
        title: "Purtroppo non possiamo elaborare la tua richiesta",
        subtitle:
          "Per usufruire di questo prodotto devi essere l'unico avente diritto economico dei fondi.",
      },
      usNotAllowed: {
        title: "Purtroppo non possiamo elaborare la tua richiesta",
        subtitle:
          "Questo prodotto non è disponibile per persone che rientrano nella definizione di US Person.",
      },
      missingData: {
        title: "Purtroppo non possiamo elaborare la tua richiesta",
        subtitle:
          "Siccome mancano alcune informazioni non possiamo procedere con l’elaborazione della tua richiesta.",
      },
    },
  },
  errors: {
    input: {
      invalidPattern: "Formato non valido",
      minLength: "Sono necessari almeno {{min}} caratteri",
      maxLength: "È consentito un massimo di {{max}} caratteri",
      minPhoneLength:
        "Il numero di telefono deve essere composto da almeno {{min}} cifre.",
      required: "Campo obbligatorio",
      mismatch: "{{fieldName}} non corrisponde",
      leadingZeroNotAllowed: "La prima cifra non può essere 0",
    },
  },
  days: [
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
    "Domenica",
  ],
  captchaDisclaimer:
    "Questo sito è protetto da reCAPTCHA e si applicano le <br/> <0>norme sulla privacy</0> e i <1>termini di servizio</1> di Google.",
  captchaTooLow: {
    title: "Verifica Captcha fallita",
    description: "Per favore riprova",
  },
};
